module.exports = __webpack_public_path__ + "img/banner_red.01910630.jpg";